import Model from "../Model";

export interface TConfiguration {
  frontOfficeUrl: string;
}

export interface IConfiguration extends TConfiguration {}

const Configuration = Model((model: TConfiguration): IConfiguration => {
  const _environmentVars: TConfiguration = Object.assign({}, model);

  return {
    get frontOfficeUrl() {
      return _environmentVars.frontOfficeUrl;
    }
  };
});

export default Configuration;
